var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
// Redux
import * as redux from "redux";
import { connect } from "react-redux";
import * as Actions from "office/reports/stats/actions";
import * as Selector from "office/reports/stats/selector";
// Components
import StatsReportView from "office/reports/stats/StatsReportView";
import SummaryPage from "office/reports/stats/pages/SummaryPage";
import SalesPage from "office/reports/stats/pages/SalesPage";
import RentalsPage from "office/reports/stats/pages/RentalsPage";
import DevelopmentPage from "office/reports/stats/pages/DevelopmentPage";
import BillboardPage from "office/reports/stats/pages/BillboardPage";
import PageTabs from "external/reports/officeStats/ui/pageTabs/PageTabs";
// Helpers
import * as reportHelper from "common/utils/reportHelper";
const mapStateToProps = (state, props) => ({
    report: Selector.reportSelector(state)
});
const mapDispatchToProps = (dispatch) => ({
    actions: redux.bindActionCreators(Actions, dispatch)
});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let FeedStatsReportView = class FeedStatsReportView extends React.Component {
    constructor(props) {
        super(props);
        this.renderReport = () => {
            if (this.state.page == 1) {
                return React.createElement(SummaryPage, null);
            }
            if (this.state.page == 2) {
                return React.createElement(SalesPage, null);
            }
            if (this.state.page == 3) {
                return React.createElement(RentalsPage, null);
            }
            if (this.state.page == 4) {
                return React.createElement(DevelopmentPage, null);
            }
            if (this.state.page == 5) {
                return React.createElement(BillboardPage, null);
            }
            return null;
        };
        this.state = { page: 1 };
    }
    componentDidMount() {
        // Only fetch data if we need to
        if (reportHelper.getIfNeedsOfficeData(this.props.officeId, this.props.report)) {
            this.props.actions.getForced(this.props.officeId);
        }
    }
    render() {
        let { report } = this.props;
        let { reportData } = report;
        let isFetching = report.isFetching;
        let isError = report.isError;
        let fromDate = null;
        let toDate = null;
        if (report.reportData) {
            fromDate = reportData.fromDate;
            toDate = reportData.toDate;
        }
        //-- Handle date change
        let datePick = (fromDate, toDate) => {
            this.props.actions.getIfNeeded(reportData.officeId, [reportData.fromDate, reportData.toDate], [fromDate, toDate]);
        };
        let pageTabs;
        if (this.props.report.reportData) {
            pageTabs = (React.createElement(PageTabs, { summaryCallback: () => this.setState({ page: 1 }), salesCallback: () => this.setState({ page: 2 }), rentalsCallback: () => this.setState({ page: 3 }), developmentCallback: () => this.setState({ page: 4 }), billboardsCallback: () => this.setState({ page: 5 }), activePage: this.state.page }));
        }
        else {
            pageTabs = (React.createElement(PageTabs, null));
        }
        return React.createElement(StatsReportView, { isFetching: isFetching, isError: isError, fromDate: fromDate, toDate: toDate, datePick: (a, b) => datePick(a, b), pageTabsElement: pageTabs }, this.renderReport());
    }
};
FeedStatsReportView = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], FeedStatsReportView);
export default FeedStatsReportView;
